import { Injectable, signal } from '@angular/core';

export type LoginType = 'google' | 'yahoo';

export interface User {
  id: number;
  external_id: string;
  login_type: LoginType;
  email: string;
  name: string;
  profile_picture: string;
  created_at: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  readonly currentUser = signal<User | null>(null);
  private authCheckPromise: Promise<void> | null = null;

  async checkAuth(): Promise<void> {
    // Return existing promise if already checking
    if (this.authCheckPromise) {
      return this.authCheckPromise;
    }

    this.authCheckPromise = (async () => {
      try {
        const response = await fetch('/api/auth/user', {
          credentials: 'include',
        });
        if (response.ok) {
          const user = await response.json();
          this.currentUser.set(user);
        } else {
          this.currentUser.set(null);
        }
      } catch (error) {
        this.currentUser.set(null);
      }
    })();

    return this.authCheckPromise;
  }

  login(): void {
    const redirectUrl = localStorage.getItem('redirectAfterLogin');
    if (redirectUrl) {
      localStorage.removeItem('redirectAfterLogin');
      window.location.href = `/auth/google?redirect=${encodeURIComponent(redirectUrl)}`;
    } else {
      window.location.href = '/auth/google';
    }
  }

  loginWithYahoo(): void {
    const redirectUrl = localStorage.getItem('redirectAfterLogin');
    if (redirectUrl) {
      localStorage.removeItem('redirectAfterLogin');
      window.location.href = `/auth/yahoo?redirect=${encodeURIComponent(redirectUrl)}`;
    } else {
      window.location.href = '/auth/yahoo';
    }
  }

  async logout(): Promise<void> {
    try {
      await fetch('/auth/logout', {
        credentials: 'include',
      });
      this.currentUser.set(null);
      window.location.href = '/';
    } catch (error) {
      console.error('Logout failed', error);
    }
  }
}
